"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-in-guarano": {
    "b5dec5a2": [{
      "hkey": "08544b9e",
      "slug": "san-pietro-in-guarano",
      "name": "San Pietro in Guarano",
      "primary": true,
      "skipSearch": false
    }],
    "costa-ceci": [{
      "hkey": "08544b9e",
      "slug": "san-pietro-in-guarano",
      "name": "San Pietro in Guarano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d5b1f3f9": [{
      "hkey": "eee32742",
      "slug": "san-benedetto-in-guarano",
      "name": "San Benedetto in Guarano",
      "primary": true,
      "skipSearch": false
    }],
    "san-benedetto": [{
      "hkey": "eee32742",
      "slug": "san-benedetto-in-guarano",
      "name": "San Benedetto in Guarano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;